import React, { useContext, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AuthContext } from '../AuthContext';
import { ReactComponent as DashboardIcon } from '../../assets/svg/dashboard2.svg'
import { ReactComponent as SearchDocsIcon } from '../../assets/svg/search.svg'
import { ReactComponent as DocumentationIcon } from '../../assets/svg/documentation.svg'
import { ReactComponent as ACLIcon } from '../../assets/svg/acl.svg'
import { ReactComponent as AddresssIcon } from '../../assets/svg/address.svg'


const OrganizationUserSidebar = () => {
   
    const { user } = useContext(AuthContext); // Get user data from context
    const location = useLocation();
    console.log("location", location.pathname);
    
    const [activeNavs, setActiveNavs] = useState({ fin_account: false, link_to_store: false });
    const toggleActiveNav = (keyName) => {


        setActiveNavs({ ...activeNavs, [keyName]: activeNavs[keyName] ? false : true });

        console.log("updated", activeNavs);

    };
    return (
        <>
            {/* Sidebar Start */}
     <div className="app-nav" id="app-simple-bar">
      <ul className="main-nav p-0 mt-2">
        {/* <li className="menu-title">
          <span>Docs Milma Cloud</span>
        </li> */}
      
      
        <li className={`no-sub ${location.pathname === '/docs/search-documentations' ? 'activesidebarselected' : ''}`}>
          <Link to="/docs/search-documentations" >
             <SearchDocsIcon/>
            Search Documentations
          </Link>
        </li>
        <li className="menu-title"><span>Admin</span></li>
        <li >
          <a className={`${location.pathname === '/docs/users' || location.pathname === '/docs/roles' || location.pathname === '/docs/permissions' ? 'activesidebarselected' : ''}`} aria-expanded="false" data-bs-toggle="collapse" href="#access-control">
            <ACLIcon/>
        Access Control
          </a>
          <ul className="collapse" id="access-control">
            <li><Link to="/docs/users">Users</Link></li>
            <li><Link to="/docs/roles">Roles</Link></li>
            <li><Link to="/docs/permissions">Permissions</Link></li>
            
          </ul>
        </li>  
         <li >
          <a className={`${location.pathname === '/docs/tags' || location.pathname === '/docs/documents' ? 'activesidebarselected' : ''}`} aria-expanded="false" data-bs-toggle="collapse" href="#docs-masters">
            <DocumentationIcon/>
        Docs Master
          </a>
          <ul className="collapse" id="docs-masters">
            <li><Link to="/docs/tags">Tags</Link></li>
            <li><Link to="/docs/documents">Documents</Link></li>
           
            
          </ul>
        </li>
       

    
    
        
        
      </ul>
    </div>

        </>
    )
}

export default OrganizationUserSidebar
